import { getItemFromLocalStorage, getItemFromSessionStorage } from '@core/utils/persistenceStorage';
import { useBaseStore } from '~/stores/base';

// Проверка, что стора содержит актуальные данные
const getBaseStoreData = () => {
  try {
    const store = useBaseStore();
    if (store?.baseId) return store;
  } catch {
    // Может быть вызван вне setup() или в тестах
  }
  return null;
}

export const getCurrentBase = (): string | null => {
  const store = getBaseStoreData();
  if (store) return store.baseId;

  const isAdmin = getItemFromLocalStorage('isAdmin');
  return isAdmin
    ? getItemFromSessionStorage('base')
    : getItemFromLocalStorage('base');
};

export const getCurrentBaseName = (): string | null => {
  const store = getBaseStoreData();
  if (store) return store.baseName;

  const isAdmin = getItemFromLocalStorage('isAdmin');
  return isAdmin
    ? getItemFromSessionStorage('selectedBaseName')
    : getItemFromLocalStorage('selectedBaseName');
};